import React, { PureComponent, Fragment } from "react";
import RegisterDialog from "./RegisterDialog";
import PasswordDialog from "./PasswordDialog";
import TermsOfServiceDialog from "./TermsOfServiceDialog";
import LoginDialog from "./LoginDialog";
import EmailDialog from "./EmailDialog";
import MessageDialog from "./MessageDialog";
import ChangePasswordDialog from "./ChangePasswordDialog";
import ModalBackdrop from "../../../shared/components/ModalBackdrop";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "../../../redux/actions/auth";
import api from 'shared/functions/api/'
import { toTitleCase } from 'shared/functions/strings';

class DialogSelector extends PureComponent {
  state = {

  };

  onClose = () => {
    const { onClose } = this.props;
    onClose();
  };

  printDialog = () => {
    const {
      dialogOpen,
      openRegisterDialog,
      openLoginDialog,
      openEmailDialog,
      openPasswordDialog,
      openChangePasswordDialog,
      openMessageDialog,
      dialogOpenProps,
    } = this.props;
    const { } = this.state;
    switch (dialogOpen) {
      case "email":
        return (
          <EmailDialog
            onClose={this.onClose}
            onFormSubmit={async (values, dialogProps) => {
              const data = await this.props.emailCheck(values.email);
              if (data.exists) {
                if(data.errors && data.errors.options){
                  api.get('/configs/registration-messages')
                    .then((res) => {
                      const registrationMessages = res.data.fields;
                      if(registrationMessages[data.errors.options.status]){
                          openLoginDialog({
                            initialValues: values,
                            status: { general: <span><img alt="" src="/images/ok.svg" style={{ verticalAlign: 'middle' }} /> {registrationMessages[data.errors.options.status]}</span> },
                            description: ' '
                          });
                      }
                    });
                }else{
                  if (data.verified) {
                    openLoginDialog({
                      after: dialogProps.after,
                      initialValues: values,
                      onBack: dialogProps => openEmailDialog({ ...dialogProps, forceEnableSubmitButton: true }),
                    })
                  } else {
                    openMessageDialog({
                      initialValues: values,
                      headline: (<img alt="" src="/images/send_failed.svg" />),
                      description: <span>You have previously registered, but not verified your account. Please click the link we have sent you to verify or click the button below to resend the email.</span>,
                      submitLabel: 'Resend Email',
                      onComplete: async () => {
                        try {
                          await api.post('/resendVerification', values);
                          openMessageDialog({
                            headline: (<img alt="" src="/images/send_confirmed.svg" />),
                            description: (<span>We have sent you a new email verification to your Inbox, please check also your spam folder.</span>),
                            onComplete: () => {
                              this.onClose();
                            },
                            hideBackButton: true,
                          })
                        } catch (err) {
                          const errorMessage = toTitleCase(err.response.data.errors.msg.split('_').join(' '))
                          openMessageDialog({
                            headline: ('Error'),
                            description: errorMessage,
                            onComplete: () => {
                              this.onClose();
                            },
                            hideBackButton: true,
                          })
                        }

                      },
                      onBack: dialogProps => openEmailDialog({ ...dialogProps, forceEnableSubmitButton: true })
                    });
                  }
                }
              } else {
                openPasswordDialog({
                  initialValues: values,
                  onBack: dialogProps => openEmailDialog({ ...dialogProps, forceEnableSubmitButton: true }),
                })
              }
            }}
            {...dialogOpenProps}
          />
        );
      case "password":
        return (
          <PasswordDialog
            onClose={this.onClose}
            onContinue={values => openRegisterDialog({
              initialValues: values,
              onBack: dialogProps => openPasswordDialog({ ...dialogProps, forceEnableSubmitButton: true }),
            })}
            {...dialogOpenProps}
          />
        );
      case "register":
        return (
          <RegisterDialog
            onClose={this.onClose}
            onComplete={() => {
              openMessageDialog({
                headline: (<img alt="" src="/images/send_confirmed.svg" />),
                description: (<span>Successful form submission!<br />We have sent an email verification. Please check your Inbox and follow the Instructions.</span>),
                onComplete: () => {
                  this.onClose();
                },
                hideBackButton: true,
              })
            }}
            {...dialogOpenProps}
          />
        );
      case "message":
        return (
          <MessageDialog
            onClose={this.onClose}
            {...dialogOpenProps}
          />
        );
      case "termsOfService":
        return <TermsOfServiceDialog onClose={openRegisterDialog} />;
      case "login":
        return (
          <LoginDialog
            onClose={this.onClose}
            openChangePasswordDialog={openChangePasswordDialog}
            {...dialogOpenProps}
          />
        );
      case "changePassword":
        return (
          <EmailDialog
            description={<div>Reset your Password<br /><small style={{ color: '#cdb8a4' }}>We'll email you a reset link</small></div>}
            onClose={this.onClose}
            onBack={dialogProps => openLoginDialog({ ...dialogProps })}
            onFormSubmit={async (values) => {
              try {
                await api.post('/forgot', values);
                openLoginDialog({
                  initialValues: values,
                  status: { general: <span><img alt="" src="/images/ok.svg" style={{ verticalAlign: 'middle' }} /> We've sent you an email with a reset link.</span> },
                  description: ' '
                });
              } catch (err) {
                const errorMessage = toTitleCase(err.response.data.errors.msg.split('_').join(' '))
                openMessageDialog({
                  headline: ('Error'),
                  description: errorMessage,
                  onComplete: () => {
                    this.onClose();
                  },
                  hideBackButton: true,
                })
              }
            }}
            {...dialogOpenProps}
          />
        );
      default:
    }
  };

  render() {
    const { dialogOpen } = this.props;
    return (
      <Fragment>
        {dialogOpen && <ModalBackdrop open />}
        {this.printDialog()}
      </Fragment>
    );
  }
}

export default connect(
  (state) => ({
    authUser: state.auth.user,
  }),
  (dispatch) => bindActionCreators({ ...AuthActions }, dispatch)
)(DialogSelector);
